import { Box, Button, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as Check2CircleIcon } from '../../assets/check2-circle.svg';
import CloseIcon from '@mui/icons-material/Close';
import './tax-id-theft.css';

export interface ItemModalProps {
    onClose: () => void;
    onUploadClick: () => void;
    open: boolean;
  }
  
  export function TaxIdTheftConfirmationModal({ onClose, onUploadClick, open = false }: ItemModalProps): React.JSX.Element {
      
    return (
        <Dialog open={open} sx={{justifyContent: 'center'}} maxWidth={'xs'}>
          <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            bottom: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
            <DialogContent sx={{mt: 2}}>
                <Box sx={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                    <Check2CircleIcon height={30} width={30}/>
                    <Typography variant="h5" sx={{textAlign: 'center', mt: 2}}>
                    {'Verification Complete!'}
                    </Typography>
                    <Typography sx={{textAlign: 'center', mt: 2}}>
                    {`Thank you for verifying. You may upload a copy of your tax return, but no further actions are required at this time. Through your Optima Tax Shield subscription, we will continue to monitor your account for your safety and security.`}
                    </Typography>
                    <Box sx={{mt:3}}>
                      <a className="not-now-link me-3" onClick={onClose}>
                        Not Now
                      </a>
                      <Button className="option-primary-button" onClick={onUploadClick}>Upload My Tax Return</Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
      )
    
  }